interface StatCardProps {
	label: string;
	value: string;
	icon?: string;
	accent?: string;
}

export function StatCard({ label, value, icon, accent }: StatCardProps) {
	return (
		<div className="hud-readout">
			{icon && <span className="hud-readout__icon">{icon}</span>}
			<span className="hud-readout__label">{label}</span>
			<span className="hud-readout__value" style={accent ? { color: accent } : undefined}>
				{value}
			</span>
		</div>
	);
}
